import { pageSize } from '@/config/platform'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import useI18n from 'src/hooks/use_i18n'

import { PlatformItem, TabItem } from 'src/types'
import Card from '../Card'
import Pagination from '../Pagination'
import Search from '../Search'
import Tabs from '../Tabs'
import styles from './index.module.scss'

interface Props {
  classify: TabItem[]
  platformData: any
  query: any
}
export default function List({ classify, query, platformData }: Props) {
  const { $t } = useI18n()
  const { list = [], total = 0, page_num = 1 } = platformData || {}
  const router = useRouter()
  const search = useRef(query)
  // const [platforms, setPlatforms] = useState(list)

  // const { loading, run } = useRequest(() => queryPlatformList({ ...search.current }), {
  //   manual: true,
  //   loadingDelay: 150,
  //   debounceWait: 300,
  //   onSuccess: (res) => {
  //     search.current.total = res.data.total
  //     setPlatforms(res.data?.list || [])
  //   }
  // })
  const handleSearch = (keyword: string) => {
    search.current.t = keyword
    let searchStr = ''
    if (keyword) {
      searchStr = `t=${keyword}`
    }
    if (search.current.c) {
      searchStr += `${searchStr ? '&' : ''}c=${search.current.c}`
    }
    router.replace(
      {
        pathname: router.pathname,
        search: `?${searchStr}`
      },
      undefined
      // { shallow: true }
    )
  }

  // const handlePageChange = ({ page, eventObject }: HandlePageEventProps) => {
  //   if (typeof eventObject === 'object' && eventObject.type && typeof eventObject.preventDefault === 'function') {
  //     // 如果是事件类型，就把原事件取消掉
  //     eventObject.preventDefault()
  //   }
  //   // search.current.page_num = page
  //   // run()
  // }

  const handleTabChange = (key: string | null) => {
    search.current.c = key || ''
    search.current.t = ''
    // search.current.page_num = 1
    // run()
    router.replace(
      {
        pathname: router.pathname,
        search: key ? `?c=${key}` : ''
      },
      undefined
      // { shallow: true }
    )
  }
  return (
    <>
      <Search
        width="680px"
        placeholder={$t('ResWwwPlatform.global.__PlatformSearchPlaceholder')}
        buttonText={$t('ResWwwPlatform.global.__PlatformSearchBtn')}
        value={search.current.t}
        onSearch={handleSearch}
      />
      <Tabs tabs={classify} value={query.c} onChange={handleTabChange} />
      <ul className={styles.listMain}>
        {list?.map((item: PlatformItem, index) => (
          <li key={index}>
            <Card {...item} />
          </li>
        ))}
      </ul>
      <Pagination
        path="brands"
        // onPageChange={handlePageChange}
        classify={search.current.c}
        currentPage={page_num}
        totalPages={Math.ceil(total / pageSize)}
      />
    </>
  )
}
